// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Qtgq","containerItemsCenter":"Skeleton_containerItemsCenter__6Rgsu"};